import React from 'react';

import MobileAppBadges from './MobileAppBadges';

export default function MobileAppDownload() {
  return (
    <div
      data-testid="mobile-app-download"
      className="rounded-lg border border-primary-border-gray p-4 sm:p-6"
    >
      <div className="text-base sm:text-lg font-bold mb-2">
        Access your credit line anywhere
      </div>
      <div className="text-sm mb-4">
        Download the Credit Key iOS or Android App to add to your phone’s
        digital wallet.
      </div>
      <MobileAppBadges />
    </div>
  );
}
